<template>
  <div>
    <div
      class="dt-detail-info__content-sec dt-detail-info__content-sec--customer"
    >
      <div class="row address">
        <div class="col-md-3">
          <span class="label">Customer:</span>
          <span class="val">{{ item.booked_by.full_name }}</span>
        </div>
        <div class="col-md-3 val">
          nr:{{ item.booked_by.member_display_id }}
        </div>
      </div>
      <div class="row address">
        <div class="col-md-6">
          <span class="label">Phone:</span>
          <span class="val">{{ item.booked_by.phone }}</span>
        </div>
      </div>
      <div class="row address">
        <div class="col-md-6">
          <span class="label">Email:</span>
          <span class="val">{{ item.booked_by.email }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    item: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
